import React from "react";
import { Slider } from "antd";
import { PauseOutlined } from "@ant-design/icons";
import { ReactComponent as Loading } from "@/assets/images/loading.svg";
import { ReactComponent as PlayIcon } from "@/assets/icons/play.svg";
import { useTranslation } from "react-i18next";

import "@/assets/toGIF.less";

const ToGIFWorkContentVideoRender = ({
  toGifObj,
  playing,
  currentTimePercent,
  miniLengthLimit,
  maxLengthLimit,
  videoReady,
  pauseBtnVisible,
  handleCurrentTimeChange,
  handlePauseBtnShow,
  handlePauseBtnHide,
  handleVideoPlay,
  handleRangeChange,
  getCutPercent,
}) => {
  const { t } = useTranslation(["common"]);
  return (
    <div className="preview">
      <div className="videoWrap" id="videoRef" onMouseEnter={handlePauseBtnShow} onMouseLeave={handlePauseBtnHide}>
        <PlayIcon style={playing ? { display: "none" } : null} className="play" onClick={handleVideoPlay} />
        <PauseOutlined style={pauseBtnVisible ? null : { display: "none" }} className="pause" onClick={handleVideoPlay} />
        <video className="active" crossOrigin="Anonymous">
          <source src={toGifObj.videofileurl} type="video/mp4" />
        </video>
      </div>
      {videoReady ? (
        <div className="track">
          <div className="screenshots">
            {toGifObj.screenshots.map((item, index) => (
              <div className="screenshot" key={index}>
                {item.startsWith("blob:") ? (
                  <video
                    preload="metadata"
                    src={item}
                    className="loaded"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  ></video>
                ) : (
                  <div className="img-box" style={{ backgroundImage: `url(${item})` }}></div>
                )}
              </div>
            ))}
          </div>
          <div className="frame">
            <Slider value={currentTimePercent} tipFormatter={null} onChange={handleCurrentTimeChange} />
          </div>
          {toGifObj ? (
            <div className="range">
              <div
                className="cover"
                style={{
                  left: 0,
                  width: getCutPercent(toGifObj.start) + "%",
                }}
              ></div>
              <div
                className="cover"
                style={{
                  left: getCutPercent(toGifObj.end) + "%",
                  width: 100 - getCutPercent(toGifObj.end) + "%",
                }}
              ></div>
              <div
                className="include"
                style={{
                  left: Math.round(getCutPercent(toGifObj.start)) + "%",
                  width: Math.round(getCutPercent(toGifObj.end)) - Math.round(getCutPercent(toGifObj.start)) + "%",
                }}
              ></div>
              <Slider
                range={{ draggableTrack: true }}
                value={[getCutPercent(toGifObj.start), getCutPercent(toGifObj.end)]}
                tipFormatter={null}
                onChange={handleRangeChange}
              />
              {miniLengthLimit ? <div className="miniLengthLimit">{t("The minimum time length is xxxs!", { num: 1 })}</div> : null}
              {maxLengthLimit ? <div className="miniLengthLimit">{t("The maximum time length is 50s!")}</div> : null}
            </div>
          ) : null}
        </div>
      ) : (
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginTop: 40 }}>
          <Loading />
        </div>
      )}
    </div>
  );
};

export default ToGIFWorkContentVideoRender;
